
import React, { useEffect, useState } from "react";
import "./Login.css";
import api from '../../api/axios.js'
import { loginAdmin } from "../../utils/auth.js";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../../utils/auth";

const LoginPage = () => {

  const navigate = useNavigate();


  useEffect(() => {
    if (isLoggedIn()) {
      navigate("/dashboard", { replace: true }); // replace avoids keeping login page in history
    }
  }, [navigate]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errormesaage, setErrorMessage] = useState('')

  const handleLogin = async () => {
    try {
      setLoading(true);
      const res = await api.post("/admin/login", {
        email,
        password,
      });

      if (res.data?.success) {
        loginAdmin({
          token: res.data.token,
          admin: res.data.admin,
        });
        console.log(res, "resss")
        window.location.href = '/dashboard'
        //  navigate("/dashboard", { replace: true });
      }
    } catch (err) {
      setErrorMessage(err.response?.data?.message || "Login failed");
      // alert(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page">
      <div className="left">
        <img
          src="/login_image.svg"
          alt="Wedding"
          className="bgImage"
        />
        {/* <button className="backBtn">←</button> */}
      </div>

      <div className="right">

        <div className="card">

          <form>
            <div className="logo">
              <img src="/bandhanguru_logo.svg" alt="Bandhan Guru" />
            </div>

            <h2>Login</h2>
            <p className="subtitle">Enter your details to access your dashboard</p>

            <div className="field">
              <label>Email address or user name</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>

            <div className="field">
              <label>Password</label>
              <div className="passwordBox">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {/* <span className="eye">👁</span> */}
              </div>
            </div>
            {errormesaage && (
              <p className="error-message-login">{errormesaage}</p>
            )}

            {/* <div className="remember">
            <input type="checkbox" id="remember" defaultChecked />
            <label htmlFor="remember">Remember me</label>
          </div> */}

            <button className="loginBtn" onClick={handleLogin} disabled={loading} type="submit">
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
